/**
 * The legacy course-level price label (`course.price` + `course.isPriceFrom`)
 * is only meaningful while `priceDisplayMode` is "manual". The dashboard's
 * mode-only save path deliberately leaves the old label behind when a school
 * switches back to "auto" (so it survives a round-trip), which means a bare
 * `price`/`isPriceFrom` pair on an auto-mode course is dormant data — it must
 * never be rendered over live ticket prices.
 */
export function getLegacyManualPrice(course: any): number | undefined {
  if (
    course?.priceDisplayMode === "manual" &&
    course?.price !== undefined &&
    course?.isPriceFrom === true
  ) {
    return course.price;
  }
  return undefined;
}
